import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Trans, useTranslation } from 'next-i18next';
import { Attributes } from '../../../../components/HotelDetailsOverlay/components/AttributesSection/components/Attributes/index.js';
import { SupplierAttributes } from '../../../../components/HotelDetailsOverlay/components/AttributesSection/components/SupplierAttributes/index.js';
import { useConfig } from '../../../../components/HotelDetailsOverlay/context/Config.js';
import { Flex, HeadlineLarge, Notice, ParagraphSmall, ParagraphSmallBold } from '../../../../primitives/index.js';
import { HOTEL_DETAILS_QA_ID, qaId } from '../../../../utils/qaId.js';
export const AttributesSection = ({
  data: {
    attributes = [],
    supplierAttributes = []
  }
}) => {
  const {
    t
  } = useTranslation();
  const {
    attributes: attributesConfig
  } = useConfig();
  const favoriteAttributes = attributes.reduce((accumulator, {
    attributes: items
  }) => [...accumulator, ...items.filter(({
    name
  }) => attributesConfig.favoriteAttributes.includes(name))], []).slice(0, attributesConfig.favoriteAttributesLimit);
  return _jsxs(Flex, {
    spacing: 0,
    children: [_jsx(HeadlineLarge, {
      marginBottom: "headlines/xLarge",
      "data-testid": qaId(HOTEL_DETAILS_QA_ID, 'attributessection-headline'),
      children: t('hotelDetailsOverlay:attributesSection.headline')
    }), _jsxs(Flex, {
      spacing: "pages/small",
      children: [favoriteAttributes.length > 0 && _jsx(Attributes, {
        highlighted: true,
        title: t('hotelDetailsOverlay:attributesSection.popularAttributes.title'),
        attributes: favoriteAttributes
      }), supplierAttributes.length > 0 ? _jsx(SupplierAttributes, {
        data: supplierAttributes
      }) : _jsx(Flex, {
        divider: true,
        spacing: "dividers/medium",
        children: attributes.map(({
          translation,
          attributes,
          name
        }, index) => _jsx(Attributes, {
          title: translation,
          attributes: attributes,
          sectionName: name
        }, index))
      }), _jsx(Notice, {
        variant: "info",
        children: _jsx(ParagraphSmall, {
          color: "contentSecondary",
          children: _jsx(Trans, {
            i18nKey: "hotelDetailsOverlay:attributesSection.disclaimer",
            components: {
              bold: _jsx(ParagraphSmallBold, {
                as: "span",
                color: "contentSecondary"
              })
            }
          })
        })
      })]
    })]
  });
};